import { differenceInDays, format } from 'date-fns';
import React from 'react';
import { View } from 'react-native';
import { LABEL_HEIGHT, PositionedLabel } from './Label';
import { RunningSumLineChart, useChartWidth } from './Charts';
import { makeLineChartData } from './types';
const HorizontalAxisLabels = React.memo(({ dates }) => {
    const start = dates[0];
    const end = dates[dates.length - 1];
    // Add 1 to offset. Chart data has one more zero-point before all data.
    const labels = dates.map((date) => ({
        text: format(date, 'd MMM'),
        offset: differenceInDays(date, start) + 1,
    }));
    const length = differenceInDays(end, start) + 1;
    const width = useChartWidth();
    return (<View style={styles.container}>
      {labels.map(({ text, offset }) => (<PositionedLabel key={`${text}-${offset}-${length}`} text={text} position={offset / length} containerWidth={width}/>))}
    </View>);
});
const CustomRangeChart = ({ previous, previousColor, current, currentColor, currency, labeledDates, }) => (<>
    <RunningSumLineChart previous={previous ? makeLineChartData(previous, previousColor) : undefined} current={makeLineChartData(current, currentColor)} currency={currency}/>
    <HorizontalAxisLabels dates={labeledDates}/>
  </>);
const styles = {
    container: {
        justifyContent: 'center',
        height: LABEL_HEIGHT,
    },
};
export default CustomRangeChart;
